/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_PromoInputs */

const en_landing_promo = /** @type {(inputs: Landing_PromoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch promo · save up to 25% on yearly plans`)
};

const id_landing_promo = /** @type {(inputs: Landing_PromoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promo peluncuran · hemat sampai 25% untuk paket tahunan`)
};

/**
* | output |
* | --- |
* | "Launch promo · save up to 25% on yearly plans" |
*
* @param {Landing_PromoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_promo = /** @type {((inputs?: Landing_PromoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_PromoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_promo(inputs)
	return en_landing_promo(inputs)
});